import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class WindowResizeMixin extends Vue {

  windowWidth = window.innerWidth

  handleWindowResize({ currentTarget }: WindowEventMap['resize']): void {
    this.windowWidth = currentTarget ? (currentTarget as Window).innerWidth : window.innerWidth
  }

  mounted():void {
    window.addEventListener('resize', this.handleWindowResize)
  }

  destroyed() {
    removeEventListener('resize', this.handleWindowResize)
  }
}
